<template>
  <section>
    <div class="container trust-footer">
      <div class="columns">
        <hr />
      </div>

      <div class="row">
        <div class="small-12 medium-6 large-3 columns">
          <div class="color-gray"><span class="icon-question"></span></div>
          <h2 class="heading1">Sp&#248;rgsm&#229;l?</h2>
        </div>

        <div class="small-12 medium-6 large-3 columns">
          <div class="color-gray">Ring til os p&#229;</div>

          <div></div>

          <a href="tel:33 11 77 55">
            <h2 class="heading1">33 11 77 55</h2>
          </a>
        </div>
        <div class="small-12 medium-6 large-3 columns color-gray">
          <p>L&#230;rerstandens Brandforsikring</p>
          <p>Amerika Plads 15</p>
          <p>DK-2100 K&#248;benhavn &#216;</p>
        </div>
        <div class="small-12 medium-6 large-3 columns color-gray">
          <div class="row">
            <div class="small-6 columns"><p>Mandag - torsdag</p></div>
            <div class="small-6 columns text-right">8.30 - 16.00</div>
          </div>
          <div class="row">
            <div class="small-6 columns"><p>Fredag</p></div>
            <div class="small-6 columns text-right">10.00 - 16.00</div>
          </div>
          <div class="row">
            <div class="small-6 columns"><p></p></div>
            <div class="small-6 columns text-right"></div>
          </div>
        </div>
      </div>
    </div>
  </section>
</template>

<script>
export default {
  name: 'TrustFooter'
};
</script>
